// Animation styles shared across components

// Feed item staggered fade in animation
export const feedAnimations = `
    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(8px); }
        to { opacity: 1; transform: translateY(0); }
    }
    
    .thoughts-feed > div {
        opacity: 0;
        animation-name: fadeIn;
        animation-duration: 0.3s;
        animation-fill-mode: forwards;
        animation-timing-function: cubic-bezier(0.2, 0, 0, 1);
    }
    
    .thoughts-feed > div:nth-child(1) { animation-delay: 0.05s; }
    .thoughts-feed > div:nth-child(2) { animation-delay: 0.1s; }
    .thoughts-feed > div:nth-child(3) { animation-delay: 0.15s; }
    .thoughts-feed > div:nth-child(4) { animation-delay: 0.2s; }
    .thoughts-feed > div:nth-child(5) { animation-delay: 0.25s; }
    .thoughts-feed > div:nth-child(6) { animation-delay: 0.3s; }
    .thoughts-feed > div:nth-child(7) { animation-delay: 0.35s; }
    .thoughts-feed > div:nth-child(8) { animation-delay: 0.4s; }
    .thoughts-feed > div:nth-child(9) { animation-delay: 0.45s; }
    .thoughts-feed > div:nth-child(10) { animation-delay: 0.5s; }
    .thoughts-feed > div:nth-child(n+11) { animation-delay: 0.5s; }
`;

// Generic staggered animation that can be used with any container class
export const createStaggeredAnimation = (containerClass, itemSelector = '> div') => `
    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(8px); }
        to { opacity: 1; transform: translateY(0); }
    }
    
    .${containerClass} ${itemSelector} {
        opacity: 0;
        animation-name: fadeIn;
        animation-duration: 0.3s;
        animation-fill-mode: forwards;
        animation-timing-function: cubic-bezier(0.2, 0, 0, 1);
    }
    
    .${containerClass} ${itemSelector}:nth-child(1) { animation-delay: 0.05s; }
    .${containerClass} ${itemSelector}:nth-child(2) { animation-delay: 0.1s; }
    .${containerClass} ${itemSelector}:nth-child(3) { animation-delay: 0.15s; }
    .${containerClass} ${itemSelector}:nth-child(4) { animation-delay: 0.2s; }
    .${containerClass} ${itemSelector}:nth-child(5) { animation-delay: 0.25s; }
    .${containerClass} ${itemSelector}:nth-child(6) { animation-delay: 0.3s; }
    .${containerClass} ${itemSelector}:nth-child(7) { animation-delay: 0.35s; }
    .${containerClass} ${itemSelector}:nth-child(8) { animation-delay: 0.4s; }
    .${containerClass} ${itemSelector}:nth-child(9) { animation-delay: 0.45s; }
    .${containerClass} ${itemSelector}:nth-child(10) { animation-delay: 0.5s; }
    .${containerClass} ${itemSelector}:nth-child(n+11) { animation-delay: 0.5s; }
`;

// Pre-configured animations for common containers
export const collectionsAnimation = createStaggeredAnimation('collections-feed');
export const inboxAnimation = createStaggeredAnimation('inbox-list', '.list-item'); 